export default "<app-mat-tree [type]=\"tab\" [listName]=\"'vehicles'\"></app-mat-tree>\n<router-outlet></router-outlet>";